import type { ComponentProps } from "react";

export function Policies(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 25 25"
			{...props}
		>
			{" "}
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M11.363 14.354a.75.75 0 0 1 .177 1.045l-2.692 3.789a1.35 1.35 0 0 1-2.043.184l-1.6-1.56a.75.75 0 0 1 1.048-1.073l1.055 1.029a.5.5 0 0 0 .757-.069l2.252-3.169a.75.75 0 0 1 1.046-.176Z"
				clipRule="evenodd"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth={1.5}
				d="M13.346 18.288h6.151"
			/>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M11.363 6.356A.75.75 0 0 1 11.54 7.4L8.848 11.19a1.35 1.35 0 0 1-2.043.185l-1.6-1.56a.75.75 0 1 1 1.048-1.073L7.308 9.77a.5.5 0 0 0 .757-.069l2.252-3.169a.75.75 0 0 1 1.046-.176Z"
				clipRule="evenodd"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth={1.5}
				d="M13.346 10.29h6.151"
			/>
		</svg>
	);
}
